module.exports = __webpack_public_path__ + "static/media/score-default.291f587d.svg";